import axios from 'axios';

import { AuthenticationClient } from '../authentication/client';
import { logger } from '../logging';

import { Filter, FilterAccess, FilterContext, UserFilter } from './types';
import { FILTERS_URL } from './utils';

type GetFltersResponse = (UserFilter & {
  context: FilterContext;
  data: Record<string, unknown>;
  permissions: {
    user: {
      user_id: string;
      given_name: string;
      family_name: string;
      email: string;
    };
    access: FilterAccess;
  }[];
})[];

export async function getFilters<T extends Filter = Filter>(context: Partial<FilterContext>): Promise<T[]> {
  try {
    const token = await AuthenticationClient.getInstance().getAccessToken();

    const noUndefined = Object.entries(context).filter(([, val]) => !!val);

    const params = Object.fromEntries(noUndefined);

    const result = await axios.get<GetFltersResponse>(`/v2/filters`, {
      baseURL: FILTERS_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        ...params,
      },
    });
    return result.data.map(filter => {
      return {
        ...filter,
        permissions: filter.permissions.map(permission => ({
          user: {
            id: permission.user.user_id,
            givenName: permission.user.given_name,
            familyName: permission.user.family_name,
            email: permission.user.email,
          },
          access: permission.access,
        })),
      } as unknown as T;
    });
  } catch (e) {
    logger.error(e);
    throw e;
  }
}
